import {CLEAR_STAKES, FETCH_STAKES, LOADING_STAKES} from "../actions/actionTypes";

const initialState = {
    stakes : [],
    isLoading: true
}

const stakesReducer = (state = initialState, action) => {
    switch (action.type){
        case FETCH_STAKES:
            return {
                ...state,
                stakes : action.payload.stakes,
                isLoading: false
            }

        case LOADING_STAKES:
            return {
                ...state,
                isLoading: true
            }
        case CLEAR_STAKES:
            return {
                stakes: [],
                isLoading: false
            }
        default:
            return {
                ...state
            }
    }
}

export default stakesReducer;